import { Component, OnInit } from '@angular/core';
import { UserService } from '../../core/services/v2/user.service';
import { PhysicianService } from "../physician.service";
import { Practitioner } from '../profile/models/practitioner';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

  practitionerCopy: Practitioner;
  resultupdate: boolean;
  photoUrlsend: string;
  practitionerId = 0;
  practitioner$: BehaviorSubject<Practitioner> = new BehaviorSubject(null);

  constructor(
    private physicianService: PhysicianService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getMe().subscribe(
      (res) => {
        this.practitionerId = res.PractitionerID;
        if (this.practitionerId) {
          this.physicianService.getPractitioner(this.practitionerId).subscribe(
            (p) => {
              this.photoUrlsend = p.PhotoUrl;
              this.practitioner$.next(p);
            },
            (error) => { console.error(error); }
          );
        }
      },
      (error) => { console.error(error); }
    );
  }

  saveProfile(doctor: Practitioner) {
    this.physicianService.updatePractitioner(doctor).subscribe()
  }
}
